module.exports = __webpack_public_path__ + "img/logo_eoro.2d5958c0.png";